<template>
    <section v-if="isOpen" class="fixed top-2 w-full left-1/2 -translate-x-1/2 flex z-[9999] transition-all duration-300">
        <div class="flex relative flex-col border wrapper !w-[90%] rounded-md bg-white p-4 text-sm shadow-lg">
            <button @click="isOpen = false" class="absolute right-2 top-3 flex text-gray-500 hover:opacity-80">
                <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
            </button>
            <template v-if="Array.isArray(alertMessage)">
                <ul class="flex flex-col gap-1 m-0">
                    <li 
                        v-for="(alert, index) in alertMessage" 
                        :key="index"
                        class="flex items-center gap-2"
                        :class="classCompute(alert)"
                    >
                        <!-- draft -->
                        <svg v-if="alert.category == 'draft'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bell-icon lucide-bell"><path d="M10.268 21a2 2 0 0 0 3.464 0"/><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"/></svg>
                        <!-- pending -->
                        <svg v-if="alert.category == 'pending'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check-icon lucide-check"><path d="M20 6 9 17l-5-5"/></svg>
                        <!-- queue -->
                        <svg v-if="alert.category == 'queue'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-list-end"><path d="M16 12H3"></path><path d="M16 6H3"></path><path d="M10 18H3"></path><path d="M21 6v10a2 2 0 0 1-2 2h-5"></path><path d="m16 16-2 2 2 2"></path></svg>
                        <!-- histories -->
                        <svg v-if="alert.category == 'completed'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check-check-icon lucide-check-check"><path d="M18 6 7 17l-5-5"/><path d="m22 10-7.5 7.5L13 16"/></svg>
                        <!-- cancelled -->
                        <svg v-if="alert.category == 'cancelled'" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-x-icon lucide-circle-x"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
                        <span class="flex mt-1 text-black">{{ alert.message }}</span>
                    </li>
                </ul>
            </template>
            <span v-else>{{ alertMessage }}</span>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import { eventBus } from '../main';

export default {
    name: "OrderAlert",

    data() {
        return {
            isOpen: false,
            alertMessage: [],
            uuids: localStorage.getItem('fs_uuids_track') ? JSON.parse(localStorage.getItem('fs_uuids_track')) : [],
            orderStates: {}, 
            pollingInterval: null,
            notificationSound: null,
            shownStatuses: localStorage.getItem('shown_order_statuses') 
                ? JSON.parse(localStorage.getItem('shown_order_statuses')) 
                : {},
            ordersCount: 0
        }
    },

    mounted() {
        this.notificationSound = new Audio('/notification.mp3');
        // this.fetchOrderStatus();

        // iOS Safari outside a home-screen web app exposes Notification without requestPermission
        if (window.Notification && typeof Notification.requestPermission === 'function' && Notification.permission !== 'granted') {
            if (Notification.permission === 'default' || Notification.permission === 'denied') {
                Notification.requestPermission();
            }
        }

        this.pollingInterval = setInterval(async() => {
            await this.fetchOrderStatus()
        }, 5000)
        eventBus.$on('orders-tracking-cleared', this.stopTracking)
    },

    beforeDestroy() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    },

    methods: {
        stopTracking() {
            this.uuids = [];
            this.ordersCount = 0;
            clearInterval(this.pollingInterval);
            this.pollingInterval = null
        },

        classCompute(alert) {
            const firstAlertCategory = alert.category;

            switch (firstAlertCategory) {
                case 'completed':
                    return 'text-green-500';
                case 'cancelled':
                    return 'text-red-500';
                case 'pending':
                    return 'text-blue-500';
                case 'queue':
                case 'draft':
                    return 'text-orange-500';
                default:
                    return 'text-gray-700';
            }
        },

        async fetchOrderStatus() {
            if (!this.uuids.length) return;

            this.uuids = localStorage.getItem('fs_uuids_track') ? JSON.parse(localStorage.getItem('fs_uuids_track')) : [];

            try {
                const response = await axios.get(process.env.VUE_APP_API_URL + 'hotels/' + this.$root.hotelCode + '/orders/check', {
                    params: { order_uuids: this.uuids }
                })
                
                this.processOrderData(response.data);

            } catch(err) {
                console.error("Error fetching status: ", err)
            }
        },

        processOrderData(data) {
            this.ordersCount = 0
            const categories = [
                {
                    key: 'completed',
                    label: { en: 'Completed', fr: 'Complétée', ru: 'Заказ выполнен' },
                    msg: { en: 'has been completed', fr: 'a été complétée', ru: 'заказ успешно выполнен' }
                },
                {
                    key: 'cancelled',
                    label: { en: 'Cancelled', fr: 'Annulée', ru: 'Заказ отменён' },
                    msg: { en: 'has been cancelled', fr: 'a été annulée', ru: 'заказ был отменён' }
                },
                {
                    key: 'pending',
                    label: { en: 'Preparing', fr: 'Préparation', ru: 'Заказ готовится' },
                    msg: { en: 'is being prepared', fr: 'est en préparation', ru: 'заказ сейчас готовится' }
                },
                {
                    key: 'queue',
                    label: { en: 'In Queue', fr: 'En file d\'attente', ru: 'Заказ в очереди' },
                    msg: { en: 'is in the queue', fr: 'est dans la file d\'attente', ru: 'заказ находится в очереди на обработку' }
                },
                {
                    key: 'draft',
                    label: { en: 'Received', fr: 'Reçue', ru: 'Заказ получен системой' },
                    msg: { en: 'has been received', fr: 'a été reçue', ru: 'заказ был успешно получен' }
                },
            ];

            const categoryMap = categories.reduce((map, cat) => {
                map[cat.key] = cat;
                return map;
            }, {});

            const newAlerts = [];

            const countKeys = ['draft', 'pending', 'queue'];

            countKeys.forEach(key => {
                if (data[key] && Array.isArray(data[key])) {
                    this.ordersCount += data[key].length;
                }
            });

            this.$root.$emit('orders-count-updated', this.ordersCount);

            this.uuids.forEach(uuid => {
                let foundStatus = null;
                let foundOrder = null;
                let foundMsg = "";
                let foundCategoryKey = "";

                const statusKeys = ['pending', 'queue', 'draft'];

                for (const key of statusKeys) {
                    if (data[key] && Array.isArray(data[key])) {
                        const order = data[key].find(o => o.uuid === uuid);
                        if (order) {
                            foundStatus = key;
                            foundOrder = order;
                            foundCategoryKey = key;
                            foundMsg = this.$root.getLangText(categoryMap[key].msg);
                            break;
                        }
                    }
                }

                if (!foundOrder && data['histories'] && Array.isArray(data['histories'])) {
                    const order = data['histories'].find(o => o.uuid === uuid);
                    
                    if (order) {
                        foundOrder = order;
                        const statusId = order.ostatus_id;

                        if (statusId === 'cancelled' && categoryMap['cancelled']) {
                            foundStatus = 'cancelled';
                            foundCategoryKey = 'cancelled';
                            foundMsg = this.$root.getLangText(categoryMap['cancelled'].msg);
                        } 
                        else if (categoryMap['completed']) { 
                            foundStatus = 'completed';
                            foundCategoryKey = 'completed';
                            foundMsg = this.$root.getLangText(categoryMap['completed'].msg);
                        }
                    }
                }
                
                if (foundStatus) {
                    const alertObject = this.getAlertIfChanged(uuid, foundStatus, foundMsg, foundOrder, foundCategoryKey);
                    if (alertObject) {
                        newAlerts.push(alertObject);
                    }
                }
            });

            if (newAlerts.length > 0) {
                this.alertMessage = newAlerts;
                this.isOpen = true;
                this.playNotificationSound();
            } else {
            }
        },

        getAlertIfChanged(uuid, newStatus, messageSuffix, orderData, categoryKey) {
            const lastStatus = this.orderStates[uuid]; 

            const lastShownStatus = this.shownStatuses[uuid];

            let shouldShowAlert = false;

            if (lastStatus === undefined) {
                if (lastShownStatus !== newStatus) {
                    shouldShowAlert = true;
                }
            } else {
                if (lastStatus !== newStatus) {
                    shouldShowAlert = true;
                }
            }
            
            if (shouldShowAlert) {
                this.orderStates[uuid] = newStatus;

                this.shownStatuses[uuid] = newStatus;
                localStorage.setItem('shown_order_statuses', JSON.stringify(this.shownStatuses));

                const orderNum = orderData.num || '';
                
                return {
                    category: categoryKey,
                    message: `Order ${orderNum ? '#' + orderNum : ''} ${messageSuffix}`
                };
            }
            return null; 
        },

        updateAlertIfChanged(uuid, newStatus, messageSuffix, orderData) {
            const lastStatus = this.orderStates[uuid];

            if (lastStatus !== newStatus) {
                this.orderStates[uuid] = newStatus;

                const orderNum = orderData.num || orderData.num || '';
                this.alertMessage = `Order ${orderNum ? '#' + orderNum : ''} ${messageSuffix}`;
                
                this.isOpen = true;

                this.playNotificationSound()
                setTimeout(() => {
                    // this.isOpen = false;
                }, 8000);
            }
        },
        
        playNotificationSound() {
            if (this.notificationSound) {
                this.notificationSound.currentTime = 0;
                this.notificationSound.play().catch(error => {
                    console.log("Audio play failed:", error);
                });
            }
        },
    }
}
</script>